import { useCallback, useEffect, useState } from 'react'
import { api } from './api'

/** Load one endpoint. Reload on demand. Errors are strings a person can read. */
export function useApi<T>(path: string | null) {
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(Boolean(path))
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick((t) => t + 1), [])

  useEffect(() => {
    if (!path) { setData(null); setLoading(false); return }
    let alive = true
    setLoading(true)
    api<T>(path)
      .then((d) => { if (alive) { setData(d); setError(null) } })
      .catch((e: Error) => { if (alive) setError(e.message) })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [path, tick])

  return { data, error, loading, reload }
}
